"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = void 0;
var _react = require("react");
var _constants = require("../../constants");
var _internals = require("../../internals");
var _GenericContent = require("../GenericContent");
var _WafContent = require("../WafContent");
var _errorCodeTranslationKeys = require("./errorCodeTranslationKeys");
var _errorPageTranslations = require("./errorPageTranslations");
var _jsxRuntime = require("react/jsx-runtime");
const Content = ({
  statusCode: rawErrorCode,
  language,
  operationId,
  operationResourceId,
  environment,
  developmentInfo
}) => {
  // This runs ONLY on mount and won't re-run on re-renders
  // eslint-disable-next-line react/hook-use-state -- useState is used to avoid re-renders, we don't need setter
  const [initialState] = (0, _react.useState)(() => {
    // Prefer language from URL query, than from props, falls back to browser language
    const initialLanguage = (0, _internals.getUrlQueryParam)('language') ?? language ?? (0, _internals.getCurrentBrowserLanguage)();
    // OperationId URL param will override operationId from props
    const initialOperationId = (0, _internals.getUrlQueryParam)('operation-id') ?? operationId;
    // Message from URL query - used by Online in Maintenance pages and by WAF
    const initialMessage = (0, _internals.getUrlQueryParam)('message');
    // Operation Id could be set either from ASMS or with any other system through query params
    // this is mainly used for creating a link in non-live environments that will quickly
    // take user to transaction
    const initialOperationResourceId = (0, _internals.getUrlQueryParam)('operation-resource-id') ?? operationResourceId;
    return {
      currentLanguage: initialLanguage,
      currentOperationId: initialOperationId,
      currentMessage: initialMessage,
      currentOperationResourceId: initialOperationResourceId
    };
  });
  const {
    currentLanguage,
    currentOperationId,
    currentMessage,
    currentOperationResourceId
  } = initialState;

  // We can accept any error code but we have to limit internally to only supported ones
  const errorCode = (0, _react.useMemo)(() => _constants.SUPPORTED_ERROR_CODES.includes(rawErrorCode) ? rawErrorCode : 0, [rawErrorCode]);

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- okay here
  const translations = _errorPageTranslations.errorPageTranslations[currentLanguage] ?? _errorPageTranslations.errorPageTranslations.en;
  const {
    buttonText: buttonTextTranslationKey,
    headline: headlineTranslationKey,
    text: textTranslationKey,
    contactSupportTeam: contactSupportTeamTranslationKey
  } = (0, _react.useMemo)(() => _errorCodeTranslationKeys.errorCodeTranslationKeys[errorCode], [errorCode]);
  switch (errorCode) {
    case 1:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_WafContent.WafContent, {
        errorCode: errorCode,
        headerText: translations[headlineTranslationKey],
        messageText: currentMessage ?? translations[textTranslationKey],
        contactSupportTeamText: translations[contactSupportTeamTranslationKey],
        errorButtonText: translations[buttonTextTranslationKey]
      });
    default:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_GenericContent.GenericContent, {
        errorCode: errorCode,
        operationId: currentOperationId,
        headerText: translations[headlineTranslationKey],
        messageText: currentMessage ?? translations[textTranslationKey],
        errorButtonText: translations[buttonTextTranslationKey],
        operationResourceId: currentOperationResourceId,
        developmentInfo: developmentInfo,
        environment: environment
      });
  }
};
exports.Content = Content;
